import React, { useState, useEffect } from "react";
import Clipboard from "react-clipboard.js";
import Emojis from "./emojis/Emojis";
import paginate from "../utils/paginate";
import Copied from "./Copied.jsx";
import Footer from "./Footer";
import Header from "./common/Header";
import Search from "./common/Search";
const emojis = require("./emojis/emojisLabel.json").emojis;

const All = () => {
  const [search, setSearch] = useState("");
  const [filtred, setFiltred] = useState(emojis);
  const pageSize = 700;
  const [currentPage, setCurrentPage] = useState(1);
  const [olderPage, setOlderPage] = useState(1);
  const [newerPage, setNewerPage] = useState(2);
  const [copied, setCopied] = useState(false);
  const [emojiCopied, setEmojiCopied] = useState("");

  useEffect(() => {
    setCurrentPage(1);
    if (search.length === 0) setFiltred(emojis);
    else
      setFiltred(
        emojis.filter((item) =>
          item.label.toLocaleLowerCase().includes(search.toLocaleLowerCase())
        )
      );
  }, [search]);

  const getEmojis = paginate(filtred, currentPage, pageSize);
  const handleCopied = (emoji) => {
    setEmojiCopied(emoji);
    setCopied(true);

    setTimeout(() => setCopied(false), 1000);
  };
  return (
    <>
      <div className="app">
        <div className="container">
          <div>
            <Header />
            <Search search={search} setSearch={setSearch} />
            <div className="emojis">
              {getEmojis.map((item) => (
                <Clipboard
                  key={item.label}
                  data-clipboard-text={`<Emojis data="${item.id}" />`}
                  onSuccess={() => handleCopied(item.id)}
                >
                  <div className="emoji">
                    <img src={item.svg} alt={item.emoji} />
                    <span className="tooltip">{item.label} </span>
                  </div>
                </Clipboard>
              ))}
            </div>
            {/*<div className="paginate">
              <button
                onClick={() => {
                  if (olderPage !== 1) {
                    setOlderPage(olderPage - 1);
                    setNewerPage(newerPage - 1);
                    setCurrentPage(currentPage - 1);
                  }
                }}
              >
                Older
              </button>
              <button
                onClick={() => {
                  setOlderPage(olderPage + 1);
                  setNewerPage(newerPage + 1);
                  setCurrentPage(currentPage + 1);
                }}
              >
                Newer
              </button>
              </div>*/}
          </div>
        </div>
      </div>
      <Copied show={copied} emoji={emojiCopied} />
      <Footer />
    </>
  );
};

export default All;
